import React, { Component } from 'react'
import { toJS } from 'mobx'
import { tokenStorage } from '@atheneum/api/dist/lib'
import Action from '@components/Action'
import DownloadIcon from '@components/Icon/Download'
import queryString from 'query-string'
import omit from 'lodash/omit'
import PropTypes from 'prop-types'

export default class Actions extends Component {
  handleExportClick = () => {
    const query = toJS(this.props.contractSearchStore.query)
    const token = tokenStorage.get()
    const queryStr = queryString.stringify({
      ...omit(query, ['page', 'limit']),
      token
    })
    const url = `/api/contract/export?${queryStr}`
    window.open(url)
  }

  render () {
    const { contracts } = this.props.contractSearchStore
    return (
      <div className='actions-wrapper actions-wrapper--contracts'>
        <ul className='actions'>
          <li>
            <Action
              onClick={this.handleExportClick}
              disabled={!contracts.length}
            >
              <DownloadIcon />
              <span>Export</span>
            </Action>
          </li>
        </ul>
      </div>
    )
  }

  static propTypes = {
    contractSearchStore: PropTypes.object
  }
}
